import axios from '../../axios'

export default {
    getProductType: () => axios.get('/api/api/wechat/video/product/type'),//获取产品类型
    getProductList: (data) => axios.get('/api/api/wechat/video/product/type/list', data),//获取产品列表
    getProductAdd: (data) => axios.post('/api/api/wechat/video/add', data),//创建   /api/api/wechat/video/list
    getProductState: (data) => axios.get('/api/api/wechat/video/status', data),// 获取状态
    getList: (data) => axios.get('/api/api/wechat/video/list', data),//获取生成的推广产品链接列表
    delVideo: (data) => axios.post('/api/api/wechat/video/del', data),//删除生成的推广产品链接
}